<c-sidebar
  #leftPanel="cSidebar"
  [ngStyle]="{
    visibility: visibility ? 'visible' : 'hidden',
    transition: 'width 0.3s ease-in-out',
    width: expanded ? '225px' : '42px',
  }"
  [ngClass]="{
    'sidebar-expanded': expanded,
    'sidebar-unexpanded': !expanded,
    'sidebar-disabled': disabled,
  }"
  class="d-print-none sidebar sidebar-light"
  id="leftPanel"
  visible="{{ visible }}"
  [narrow]="!expanded"
  placement="start"
>
  <ng-scrollbar #scrollbar="ngScrollbar" class="overflow" pointerEventsMethod="scrollbar" visibility="hover">
    @if (navItems.length && expanded) {
      <c-sidebar-nav #overflow [navItems]="navItems" dropdownMode="close" [compact]="!expanded" />
    }

    <!-- Custom navigation for unexpanded state with tooltips -->
    @if (navItems.length && !expanded) {
      <ul class="sidebar-nav">
        @for (item of navItems; track $index) {
          <li class="nav-item">
            @if (item.url && !item.children) {
              <a
                [routerLink]="item.url"
                class="nav-link"
                [class.active]="isLinkActive(item.url)"
                [appSidebarTooltip]="item.name || ''"
                [showTooltip]="!expanded"
              >
                @if (item.icon) {
                  <i class="nav-icon" [ngClass]="item.icon"></i>
                }
              </a>
            }

            <!-- For dropdown items, show only the parent with tooltip showing all children -->
            @if (item.children && item.children.length) {
              <div
                class="nav-link dropdown-parent"
                [appSidebarTooltip]="item.name || ''"
                [showTooltip]="!expanded"
                [isDropdown]="true"
                [dropdownItems]="getDropdownItemNames(item)"
                [systemService]="systemService"
              >
                @if (item.icon) {
                  <i class="nav-icon" [ngClass]="item.icon"></i>
                }
              </div>
            }
          </li>
        }
      </ul>
    }
  </ng-scrollbar>
</c-sidebar>
